module.exports = __webpack_public_path__ + "img/chess_chinesechessblack3.243c9f7a.png";